import { render, staticRenderFns } from "./TableContent.vue?vue&type=template&id=6d34dacc&scoped=true"
import script from "./TableContent.vue?vue&type=script&lang=js"
export * from "./TableContent.vue?vue&type=script&lang=js"
import style0 from "./TableContent.vue?vue&type=style&index=0&id=6d34dacc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d34dacc",
  null
  
)

export default component.exports